import React from 'react';
import { FieldLabel } from './FieldLabel';
import { TEXTAREA_KEYS } from './_editor_helpers';

export default function BilingualField({ k, value, onChange }) {
  const v = value || {};
  const useTextarea = TEXTAREA_KEYS.has(k);
  const Tag = useTextarea ? 'textarea' : 'input';
  return (
    <div className="space-y-2">
      <FieldLabel k={k}>{k}</FieldLabel>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {['es', 'en'].map((lang) => (
          <div key={lang} className="bg-bg-secondary border border-line rounded-md p-3">
            <div className="text-eyebrow text-acid mb-1">{lang.toUpperCase()}</div>
            <Tag
              data-testid={`field-${k}-${lang}`}
              rows={Tag === 'textarea' ? 3 : undefined}
              value={v[lang] || ''}
              onChange={(e) => onChange({ ...v, [lang]: e.target.value })}
              className="w-full bg-transparent text-ink outline-none border-0 resize-none text-sm font-mono"
              placeholder={lang === 'es' ? 'Texto en español' : 'English text'}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
